module.exports = __webpack_public_path__ + "img/profile-picture-lambrecht-min.90e0d4bd.png";